import { useLocation } from 'react-router-dom';
import rightBannerImg from 'assets/img/right_banner.gif';

const BANNER_URL =
    'https://www.rustore.ru/catalog/app/com.profootball.profootball?_rsc=Bl87od1bNOqMZDgt';

const useRightSideBanners = () => {
    const { pathname } = useLocation();
    const pathnameFirstSegment = pathname.split('/')[1];
    let banners = null;

    switch (pathnameFirstSegment) {
        case 'matches':
        case 'league':
        case 'fixture':
        case 'team':
        case 'favorites':
        case 'stats':
        case 'player':
        case 'videos':
        case 'news':
            banners = [
                <a
                    key="bannerAd1"
                    href={BANNER_URL}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ display: 'block', width: 320, maxWidth: '100%' }}
                >
                    <img
                        src={rightBannerImg}
                        alt="InScore"
                        style={{
                            display: 'block',
                            width: '100%',
                            height: 'auto',
                        }}
                    />
                </a>,
            ];
            break;
        default:
            banners = null;
    }

    return banners;
};

export default useRightSideBanners;
